<script setup lang="ts">
import { RouterLink } from 'vue-router';
</script>

<template>
  <div class="mx-auto max-w-[960px] px-11 pb-20 pt-[34px]">
    <div class="px-5 py-[60px] text-center text-dim-2">
      <svg
        class="mx-auto mb-3.5 size-[38px] opacity-50"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4 6.5C4 5 5 4 6.5 4h11C19 4 20 5 20 6.5v11c0 1.5-1 2.5-2.5 2.5h-11C5 20 4 19 4 17.5v-11Z"
          stroke="currentColor"
          stroke-width="1.6"
        />
      </svg>
      <p>Page not found.</p>
      <p class="mt-3">
        <RouterLink to="/collect">Back to Collect</RouterLink>
      </p>
    </div>
  </div>
</template>
